const validateApiResponse = res => {
  const valid_responses = [200, 201, 202, 204];
  return valid_responses.includes(res.status);
};

export { validateApiResponse };
